import { api } from "@/services/api";
import {
  CreateInventoryItemRequest,
  CreateInventoryMovementRequest,
  ConsumeStationSuppliesRequest,
  CreateStationSupplyRequirementRequest,
  UpdateInventoryItemRequest,
  UpdateStationSupplyRequirementRequest,
  ValidateStockRequest,
} from "@/types/inventory";

export const inventoryService = {
  getInventoryItems: async (slug: string, params?: { search?: string; low_stock?: boolean }) => {
    return api.get("/inventory", {
      params: {
        slug,
        ...params,
      },
    });
  },

  createInventoryItem: async (data: CreateInventoryItemRequest) => {
    return api.post("/inventory", data);
  },

  updateInventoryItem: async (id: string, data: UpdateInventoryItemRequest) => {
    return api.put(`/inventory/${id}`, data);
  },

  deleteInventoryItem: async (id: string, slug: string, company_id: string) => {
    return api.delete(`/inventory/${id}`, {
      data: { slug, company_id },
    });
  },

  getStationConfigurations: async (slug: string, params?: { station_name?: string }) => {
    return api.get("/inventory/station-configurations", {
      params: {
        slug,
        ...params,
      },
    });
  },

  createStationConfiguration: async (data: CreateStationSupplyRequirementRequest) => {
    return api.post("/inventory/station-configurations", data);
  },

  updateStationConfiguration: async (
    id: string,
    data: UpdateStationSupplyRequirementRequest,
  ) => {
    return api.put(`/inventory/station-configurations/${id}`, data);
  },

  deleteStationConfiguration: async (id: string, slug: string, company_id: string) => {
    return api.delete(`/inventory/station-configurations/${id}`, {
      data: { slug, company_id },
    });
  },

  getReplenishmentDashboard: async (slug: string) => {
    return api.get("/inventory/replenishment", {
      params: { slug },
    });
  },

  getInventoryMovements: async (slug: string, params?: { movement_type?: string; limit?: number }) => {
    return api.get("/inventory/movements", {
      params: {
        slug,
        ...params,
      },
    });
  },

  createInventoryMovement: async (data: CreateInventoryMovementRequest) => {
    return api.post("/inventory/movements", data);
  },

  consumeStationSupplies: async (data: ConsumeStationSuppliesRequest) => {
    return api.post("/inventory/consume", data);
  },

  validateStock: async (data: ValidateStockRequest) => {
    return api.post("/inventory/validate-stock", data);
  },
};
